import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'cna-collapse-icon',
    templateUrl: './collapse-icon.component.html',
    styleUrls: ['./collapse-icon.component.scss'],
})
export class CollapseIconComponent {}
